__turbopack_context__.v({
  "fill": "material-module-scss-module__l5MlDq__fill",
  "icon": "material-module-scss-module__l5MlDq__icon",
  "outlined": "material-module-scss-module__l5MlDq__outlined",
  "round": "material-module-scss-module__l5MlDq__round",
  "sharp": "material-module-scss-module__l5MlDq__sharp",
});
